import { IObject, base } from "@quest/base-core";
import { reelPanel, slot } from "@quest/slot-core";
import { BehaviorCoreModule } from "@quest/murka-games-behavior-leopard/dist";

//  BASE GAME
import { BaseControllerGame } from "./Base/BaseControllerGame";
import { BaseGameViewGame } from "./Base/BaseGameViewGame";
import { MetersControllerGame } from "./Base/MetersControllerGame";
import { ButtonControllerGame } from "./Base/ButtonControllerGame";
import { ReelPanelControllerGame } from "./Base/ReelPanelControllerGame";
import { WinPresentationControllerGame } from "./Base/WinPresentationControllerGame";
import { BaseGameModel } from "./model/BaseGameModel";
import { GameClientLogic } from "./Logic/GameClientLogic";
import { gameConstants } from "./Constants/gameConstants";
import { SettingPanelController } from "./Base/SettingPanelController";
import { BackgroundViewGame } from "./Background/BackgroundViewGame";
import { WinPresentationPanelGame } from "./ReelPanel/WinPresentationPanelGame";
import { PlayerMsgControllerGame } from "./playermessage/PlayerMsgControllerGame";
import { PlayerMsgViewGame } from "./playermessage/PlayerMsgViewGame";


//  INTRO OUTRO
import { IntroOutroControllerGame } from "./IntroOutro/IntroOutroControllerGame";
import { IntroOutroViewGame } from "./IntroOutro/IntroOutroViewGame";
import { GameIntroControllerGame } from "./GameIntro/GameIntroControllerGame";
import { GameIntroViewGame } from "./GameIntro/GameIntroViewGame";
// BIG WIN
import { BigWinControllerGame } from "./BigWin/BigWinControllerGame";
import { BigWinControllerFgGame } from "./BigWin/BigWinControllerFgGame";

//BOTTOM BAR
import { BottomBarControllerGame } from "./BottomBar/BottomBarControllerGame";

// REEL
import { ReelAT } from "./ReelPanel/Reel";
//METER
import { MeterGame } from "./UI/MeterGame";
import { MeterBitmapGame } from "./UI/MeterBitmapGame";
// FREE GAME
import { View } from "./FreeGame/View";
import { FreeGameControllerGame } from "./FreeGame/FreeGameControllerGame";
import { FreeGameReelPanelControllerGame } from "./FreeGame/FreeGameReelPanelController";
import { BackgroundControllerGame } from "./Background/BackgroundControllerGame";
import { FreeGameWinPresentationControllerGame } from "./FreeGame/FreeGameWinPresentationControllerGame";
import { BigWinViewGame } from "./BigWin/BigWinViewGame";
import { FreeGameModel } from "./model/FreeGameModel";
import { MetersControllerFreeGame } from "./FreeGame/MetersControllerFreeGame";
import { RetriggerControllerGame } from "./Retrigger/RetriggerController";
import { RetriggerViewGame } from "./Retrigger/RetriggerViewGame";
import { BlurBackgroundViewGame } from "./BlurBackground/BlurBackgroundView";
import { BlurBackgroundControllerGame } from "./BlurBackground/BlurBackgroundController";
import { AutoplayPopupViewGame } from "./Autoplay/AutoplayPopupViewGame";
import { DeviceDetectorGame } from "./DeviceDetectorGame";
import { FreeGameButtonControllerGame } from "./FreeGame/FreeGameButtonControllerGame";
import { FreePlayViewGame } from "./FreePlay/FreePlayViewGame";



// This is only for adding coreModuleList in final game js else use gameConstants directly//
export let game: IObject = {
  gameConstants: gameConstants,
};

BehaviorCoreModule.BigWinView = BigWinViewGame;
BehaviorCoreModule.FreeGameController = FreeGameControllerGame;
BehaviorCoreModule.FreeGameView = View;
BehaviorCoreModule.BaseController = BaseControllerGame;
BehaviorCoreModule.BaseView = BaseGameViewGame;
BehaviorCoreModule.BackGroundView = BackgroundViewGame;
BehaviorCoreModule.IntroOutroController = IntroOutroControllerGame;
BehaviorCoreModule.IntroOutroView = IntroOutroViewGame;
BehaviorCoreModule.GameIntroController = GameIntroControllerGame;
BehaviorCoreModule.GameIntroView = GameIntroViewGame;
BehaviorCoreModule.SettingPannelController = SettingPanelController;
BehaviorCoreModule.BigWinControllerFg = BigWinControllerFgGame;
slot.SlotLogic = GameClientLogic;
slot.BaseWinPresentationController = WinPresentationControllerGame;
slot.BaseReelPanelController = ReelPanelControllerGame;
slot.BaseMetersController = MetersControllerGame;
slot.BaseButtonController = ButtonControllerGame;
BehaviorCoreModule.FreeGameMetersController = MetersControllerFreeGame;
BehaviorCoreModule.FreeGameButtonController = FreeGameButtonControllerGame;
BehaviorCoreModule.FreeGameView = View;
BehaviorCoreModule.BigWinController = BigWinControllerGame;
BehaviorCoreModule.FreeGameReelPanelController = FreeGameReelPanelControllerGame;
BehaviorCoreModule.BaseModel = BaseGameModel;
BehaviorCoreModule.BackgroundController = BackgroundControllerGame;
BehaviorCoreModule.FreeGameWinPresentationController = FreeGameWinPresentationControllerGame;
BehaviorCoreModule.FreeGameModel = FreeGameModel;
BehaviorCoreModule.PlayerMsgController = PlayerMsgControllerGame;
BehaviorCoreModule.PlayerMsgView = PlayerMsgViewGame;
BehaviorCoreModule.BottomBarController = BottomBarControllerGame;
BehaviorCoreModule.RetriggerController = RetriggerControllerGame
BehaviorCoreModule.RetriggerView = RetriggerViewGame
reelPanel.Reel = ReelAT;
reelPanel.WinReelPanel = WinPresentationPanelGame;
base.Meter = MeterGame;
base.MeterBitmap = MeterBitmapGame;
base.DetectDeviceEnvironment = DeviceDetectorGame;
BehaviorCoreModule.BlurBackgroundView = BlurBackgroundViewGame;
BehaviorCoreModule.BlurBackgroundController = BlurBackgroundControllerGame;
BehaviorCoreModule.AutoPlayPopUpView = AutoplayPopupViewGame;
BehaviorCoreModule.FreePlayView = FreePlayViewGame;
